import {StatusGroupType} from '../../../models/mongoose/StatusModel/enum/StatusGroupType'
import {ParticularColorType} from '../../ColorService/enum/ParticularColorType'
import {IParticularColor} from '../../ColorService/types/IParticularColor'

export interface IStatusGroupPresentation {
  position: number
  color: IParticularColor<ParticularColorType.Palette>
}

export const StatusGroupPresentationMap = new Map<StatusGroupType, IStatusGroupPresentation>([
  [StatusGroupType.NotStarted, {
    position: 0,
    color: {
      colorType: ParticularColorType.Palette,
      payload: 13,
    },
  }],
  [StatusGroupType.Active, {
    position: 1,
    color: {
      colorType: ParticularColorType.Palette,
      payload: 5,
    },
  }],
  [StatusGroupType.Completed, {
    position: 2,
    color: {
      colorType: ParticularColorType.Palette,
      payload: 8,
    },
  }],
  [StatusGroupType.Closed, {
    position: 3,
    color: {
      colorType: ParticularColorType.Palette,
      payload: 1,
    },
  }],
  [StatusGroupType.Other, {
    position: 4,
    color: {
      colorType: ParticularColorType.Palette,
      payload: 10,
    },
  }],
])
